module.exports = __webpack_public_path__ + "media/images/help/site-create-edit-9c159d10719fd5e475ec31450b9bf3e4.png";